<template>
    <div>
        <el-dialog
            :visible.sync="show"
            width="75%"
            center
            style="height: 400px;"
            @close="close"
            :append-to-body="true">
            <div style="text-align: center;margin-top: 30px">
                <span style="margin-right: 25px">请选择价格库类别:</span>
                <el-select
                    class="minWidth"
                    size="mini"
                    v-model="searchForm.rootCategoryId"
                    @change="getFirst(searchForm.rootCategoryId)"
                    placeholder="请选择">
                    <el-option
                        v-for="item in rootCategories"
                        :key="item.id"
                        :label="item.categoryName"
                        :value="item.id">
                    </el-option>
                </el-select>
                <span style="margin: 0 20px">></span>
                <el-select
                    class="minWidth"
                    size="mini"
                    v-model="searchForm.firstCategoryId"
                    @change="getSecond(searchForm.firstCategoryId)"
                    placeholder="请选择">
                    <el-option
                        v-for="item in firstLevelCategories"
                        :key="item.id"
                        :label="item.categoryName"
                        :value="item.id">
                    </el-option>
                </el-select>
                <span style="margin: 0 20px">></span>
                <el-select
                    class="minWidth"
                    size="mini"
                    v-model="searchForm.categoryId"
                    placeholder="请选择">
                    <el-option
                        v-for="item in secondLevelCategories"
                        :key="item.id"
                        :label="item.categoryName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div style="text-align: center">
                <el-button size="mini" @click="cancel" style="margin: 70px 20px 20px 20px">取消</el-button>
                <el-button size="mini" @click="submit" style="margin: 70px 20px 20px 20px">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "selectPriceLibrary",
    props:{
        flowFormId:{
            type:String,
            default:''
        },
        regionalCompanyId: {
            type: Array,
            default: null
        }
    },
    data(){
        return{
            title:'引入价格库',
            show:false,
            searchForm:{
                rootCategoryId:'',
                firstCategoryId:'',
                categoryId:''
            },
            rootCategories:[],
            firstLevelCategories:[],
            secondLevelCategories:[],

        }
    },
    methods:{
        close(){
            this.show = false;
            this.$emit('callback')
        },
        getData(categoryId = '') {
            let that = this;
            that.$root.postFunc('/v1/sSuppliersCategory/public/findSuppliersCategoryListByParent', {'categoryId': categoryId}, function (res) {
                that.rootCategories = res.data
            })
        },
        getFirst(categoryId) {
            this.searchForm.firstCategoryId=''
            this.searchForm.categoryId=''
            let that = this;
            that.$root.postFunc('/v1/sSuppliersCategory/public/findSuppliersCategoryListByParent', {'categoryId': categoryId}, function (res) {
                that.firstLevelCategories = res.data
            })
        },
        getSecond(categoryId) {
            this.searchForm.categoryId=''
            let that = this;
            that.$root.postFunc('/v1/sSuppliersCategory/public/findSuppliersCategoryListByParent', {'categoryId': categoryId}, function (res) {
                that.secondLevelCategories = res.data
            })
        },
        cancel(){
            this.show = false
        },
        submit(){
            if (!this.searchForm.categoryId){
                this.$alert('请选择价格库类别！')
                return
            }
            let that = this;
            if (this.regionalCompanyId == null || this.regionalCompanyId.length === 0){
                this.regionalCompanyId = null;
            }
            if(this.regionalCompanyId != null && this.regionalCompanyId.length > 0){
                this.regionalCompanyId = this.regionalCompanyId.join(',');
            }
            that.$root.postFunc('/v1/sPriceLibraryClauses/importLibrary', {'priceLibraryType': '1','categoryId':that.searchForm.categoryId,'flowFormId':that.flowFormId,'regionalCompanyId':that.regionalCompanyId}, function (res) {
                that.$alert(res.msg || '操作成功！',{
                    type: 'success',
                    callback: ()=>{
                        that.show = false;
                    }
                });
            })
        }
    },
    created(){
        this.getData()
    }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/common/selectPriceLibrary.vue